import React from 'react'

import JobApplicantsList from '../tables/JobApplicantsList';

import useGetTopJobApplications from '../../../hooks/misc/useGetTopJobApplications';

const TopApplicants = () => {
    const { data: topApplicants, isLoading } = useGetTopJobApplications();

    return (
        <div className="immployer__lists__page_view">
            <br />
            <JobApplicantsList
                isLoading={isLoading}
                jobApplications={topApplicants ?? []}
            />
        </div>
    )
}

export default TopApplicants;